var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H17C17.5523 3 18 3.44772 18 4V6C18 6.55228 17.5523 7 17 7H3C2.44772 7 2 6.55228 2 6V4C2 3.44772 2.44772 3 3 3ZM3 8.5H17C17.5523 8.5 18 8.94772 18 9.5V11.5C18 12.0523 17.5523 12.5 17 12.5H3C2.44772 12.5 2 12.0523 2 11.5V9.5C2 8.94772 2.44772 8.5 3 8.5ZM3 14H17C17.5523 14 18 14.4477 18 15V16C18 16.5523 17.5523 17 17 17H3C2.44772 17 2 16.5523 2 16V15C2 14.4477 2.44772 14 3 14Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.494db074b239a8b521169b811921e7ed.svg";
export { ForwardRef as ReactComponent };